// extracted by mini-css-extract-plugin
module.exports = {"seoHeading":"_1596j","seoSubHeading":"_1LEP_"};